'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTable = require('react-table');

var _reactTable2 = _interopRequireDefault(_reactTable);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
    var onClickEdit = _ref.onClickEdit,
        pastPracticeTests = _ref.pastPracticeTests,
        loading = _ref.loading;


    var columns = [{
        Header: 'Editar',
        id: 'edit',
        width: 62,
        Cell: function Cell(col) {
            return _react2.default.createElement(
                _IconButton2.default,
                { iconClassName: 'material-icons', onClick: function onClick() {
                        return onClickEdit(col.original.id);
                    } },
                'edit'
            );
        }
    }, {
        Header: 'Id',
        accessor: 'id',
        width: 240
    }, {
        Header: 'Nome',
        accessor: 'name'
    }, {
        Header: 'Nome Curto',
        accessor: 'shortName'
    }, {
        Header: 'Descrição',
        accessor: 'description'
    }, {
        Header: 'Modificada em',
        accessor: 'updatedAt',
        width: 150,
        Cell: function Cell(col) {
            return _react2.default.createElement(
                'span',
                null,
                (0, _moment2.default)(col.original.updatedAt).format('DD/MM/YYYY HH:mm')
            );
        }
    }, {
        Header: 'Criado em',
        accessor: 'createdAt',
        width: 150,
        Cell: function Cell(col) {
            return _react2.default.createElement(
                'span',
                null,
                (0, _moment2.default)(col.original.createdAt).format('DD/MM/YYYY HH:mm')
            );
        }
    }];

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactTable2.default, {
            data: pastPracticeTests,
            columns: columns,
            loading: loading,
            previousText: 'Anterior',
            nextText: 'Pr\xF3xima',
            loadingText: 'Carregando...',
            noDataText: 'N\xE3o foram encontrados simulados (exames antigos) para este filtro',
            pageText: 'P\xE1gina',
            ofText: 'de',
            rowsText: 'linhas',
            showPaginationBottom: true,
            width: 100,
            defaultPageSize: 10,
            filterable: false
        })
    );
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/components/pastPracticeTests/PastPracticeTestList.js
// module id = 3292
// module chunks = 0